module.exports = __webpack_public_path__ + "img/user.2c1229b2.svg";